import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { UncontrolledTooltip } from "reactstrap";
import { ReportSectionHeader } from "../SectionHeader";

const StatAnalysisComponent = (props) => (
    <div>
        <ReportSectionHeader>
            <div id={"statAnalysisTitle"} className={"SectionHeaderInner"}>
                {props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4? "Event Study: Statistical Significance of High-Risk Adverse Events":"Stock Price Impact: Statistical Analysis and Stock Price Residual Return"} 
            	
            </div>
            <UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
                target={"statAnalysisTitle"}>
                Single-firm multivariate regression analysis with a Control Period of a minimum of 100 observations if
                252 observations are unattainable.
            </UncontrolledTooltip>
        </ReportSectionHeader>
        <ReportTable
            settings={props.isDandO === "true"?[
                {
                    header: 'Trading Day',
                    accessor: 'date'
                },
                {
                    header: 'Closing Stock Price',
                    accessor: 'closingPrice',
                    round2Decimals: true,
                    centerRightJustified: true,
                    dollarValue: true
                },
                {
                    header: 'US Reported Trading Volume~(000s)',
                    accessor: 'reportedTradingVolume',
                    formatNumberWithCommas: true,
                    centerRightJustified: true,
                    truncateDecimal: true,
                    dollarValue: false,
                    inThousands: true,
                },
                {
                    header: 'Stock Price % Chg.', accessor: 'stockPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Daily arithmetic % return'
                },
                {
                    header: 'General Market Index % Chg.',
                    accessor: 'generalIndexPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Daily arithmetic % return of the S&P 500 Total Return Index'
                },
                {
                    header: 'Industry Index % Chg.',
                    accessor: 'industryIndexPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Please e-mail stephen@sarlit.com to attain the Index Name and Ticker used in the regression analysis.'
                },
                {
                    header: 'Stock Price Residual Return',
                    accessor: 'stockResidualReturn',
                    dollarValue: false,
                    centerRightJustified: true,
                    percentageSign: true,
                    percentageNumber: true,
                    tooltip: 'Stock price residual return presents the effects of company-specific information on the change in stock price over a single trading day'
                },
                {
                    header: 't-statistic',
                    accessor: 'tStat',
                    dollarValue: false,
                    centerRightJustified: true,
                    round2Decimals: true,
                    tooltip: 'The t-statistic, the result from a t-test, is equal to the quotient of the daily residual return and standard deviation of the cohort of residual returns exhibited during the Control Period'
                },
                {
                    header: 'Statistically Significant',
                    accessor: 'statSignificance',
                    dollarValue: false,
                    tooltip: 'The t-statistic is greater than 1.96 indicating statistical significance at the 95% Confidence Level, within two standard deviations'
                },
                {
                    header: 'Maximum Potential Damages per Share',
                    accessor: 'maxDollarOfArtificialInflationPerShare',
                    round2Decimals: true,
                    inverseValue: true,
                    dollarValue: true,
                    blockZeros : true,
                    tooltip: 'The product of the daily residual arithmetic stock price change and the closing stock price of the preceding trading day'
                }
            ] :
        	[
                {
                    header: 'Trading Day',
                    accessor: 'date'
                },
                {
                    header: 'Closing Stock Price',
                    accessor: 'closingPrice',
                    round2Decimals: true,
                    centerRightJustified: true,
                    dollarValue: true
                },
                {
                    header: 'US Reported Trading Volume~(000s)',
                    accessor: 'reportedTradingVolume',
                    formatNumberWithCommas: true,
                    centerRightJustified: true,
                    truncateDecimal: true,
                    dollarValue: false,
                    inThousands: true,
                },
                {
                    header: 'Stock Price % Chg.', accessor: 'stockPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Daily arithmetic % return'
                },
                {
                    header: 'General Market Index % Chg.',
                    accessor: 'generalIndexPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Daily arithmetic % return of the S&P 500 Total Return Index'
                },
                {
                    header: 'Industry Index % Chg.',
                    accessor: 'industryIndexPriceChangePercentage',
                    dollarValue: false,
                    percentageNumber: true,
                    centerRightJustified: true,
                    percentageSign: true,
                    tooltip: 'Please e-mail stephen@sarlit.com to attain the Index Name and Ticker used in the regression analysis.'
                },
                {
                    header: 'Stock Price Residual Return',
                    accessor: 'stockResidualReturn',
                    dollarValue: false,
                    centerRightJustified: true,
                    percentageSign: true,
                    percentageNumber: true,
                    tooltip: 'Stock price residual return presents the effects of company-specific information on the change in stock price over a single trading day'
                },
                {
                    header: 't-statistic',
                    accessor: 'tStat',
                    dollarValue: false,
                    centerRightJustified: true,
                    round2Decimals: true,
                    tooltip: 'The t-statistic, the result from a t-test, is equal to the quotient of the daily residual return and standard deviation of the cohort of residual returns exhibited during the Control Period'
                },
                {
                    header: 'Statistically Significant',
                    accessor: 'statSignificance',
                    dollarValue: false,
                    tooltip: 'The t-statistic is greater than 1.96 indicating statistical significance at the 95% Confidence Level, within two standard deviations'
                },
                {
                    header: 'Maximum Artificial Inflation per Share',
                    accessor: 'maxDollarOfArtificialInflationPerShare',
                    round2Decimals: true,
                    inverseValue: true,
                    dollarValue: true,
                    tooltip: 'The product of the daily residual arithmetic stock price change and the closing stock price of the preceding trading day'
                }
            ]}
            data={props.statResidualReturns}
            name={"statAnalysis"}
            accumulator={"maxDollarOfArtificialInflationPerShare"}
            accumulatorDisplay={props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4? "Total Max. Potential Damages per Share":"Total Max. Value of Artificial Inflation per Share"}
        />
		<div class="AceBoldText">
			* Bold <span class="AceItalicsText">records indicate {props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4 ? "Adverse Corporate Event" : "Alleged Corrective Disclosure" }</span>
		</div>
    </div>
);


export default StatAnalysisComponent;


// WEBPACK FOOTER //
// ./src/common/components/StatAnalysis/StatAnalysisComponent.js